import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconReceiptCheck: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconReceiptCheck"><Path fillRule="evenodd" clipRule="evenodd" d="M4 2V22.0204L8.375 19.6066L12 21.6066L15.625 19.6066L20 22.0204V2H4ZM9 13H15V14.5H9V13ZM15.0607 7.55003L14 6.48937L11.2 9.28937L10 8.08937L8.93934 9.15003L11.2 11.4107L15.0607 7.55003Z" fill="currentColor"/></CentralIconBase>;
});

export default IconReceiptCheck;
